import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Form, Modal, Table } from 'react-bootstrap';

import { error, inviteUser, updateUser } from '../UsersActions';
import CheckBox from '../../../components/Checkbox/Checkbox';
import RadioButton from '../../../components/RadioButton/RadioButton';
import Switch from '../../../components/Switch/Switch';

import mailIcon from '../../../assets/img/mail.svg';
import saveIcon from '../../../assets/img/save.svg';

const defaultState = {
  email: '',
  manageBilling: false,
  manageUsers: false,
  createDashboards: false,
  dashboards: [],
  search: '',
  model: {}
};

class AddUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState,
      isOpened: props.visible
    };
  }

  onButtonClick = () => {
    if (!this.state.isOpened) {
      const model = { ...this.props.model };
      if (this.props.model && this.props.model.dashboards) {
        const dashboards = {};
        _.forEach(this.props.model.dashboards, d => {
          dashboards[d.dashboardId] = {
            view: d.view,
            edit: d.edit,
            delete: d.delete
          };
        });
        model.dashboards = dashboards;
      }

      this.checkIfAllSelected(model, 'view');
      this.checkIfAllSelected(model, 'edit');
      this.checkIfAllSelected(model, 'delete');

      this.setState({
        ...defaultState,
        isOpened: true,
        dashboards: this.props.dashboards,
        manageDashboards: model && (model.manageDashboards || model.manageDashboardsViewOnly),
        model: model || {}
      });
    }
  };

  onClose = (event, propagate) => {
    if (event) {
      event.stopPropagation();
    }

    this.setState({
      isOpened: false
    });

    !!this.props.onClose && !!propagate && this.props.onClose();
  };

  onSearch = e => {
    const search = e.target.value;
    const dashboards = _.filter(this.props.dashboards, d => {
      return d.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
    });

    this.setState({ dashboards, search });
  };

  checkIfAllSelected = (model, name) => {
    const count = _.filter(model.dashboards, d => {
      return !!d[name];
    }).length;

    this.setState({ [`${name}All`]: count === this.props.dashboards.length });
  };

  handleGlobalPermissionsCheck = e => {
    const model = this.state.model;
    model[e.name] = e.checked;
    this.setState({ model });
  };

  handleManageDashboardChange = e => {
    this.setState({
      manageDashboards: !this.state.manageDashboards,
      model: {
        ...this.state.model,
        manageDashboards: false,
        manageDashboardsViewOnly: !this.state.manageDashboards
      }
    });
  };

  handleRadioBtnChange = e => {
    const model = this.state.model;
    model.manageDashboards = e.value === 'full';
    model.manageDashboardsViewOnly = e.value === 'viewonly';
    this.setState({ model });
  };

  handleAllChecked = e => {
    const model = this.state.model;
    const name = e.name.substring(0, e.name.indexOf('All'));
    _.forEach(this.state.dashboards, d => {
      if (!e.checked) {
        delete model.dashboards[d._id][name];
      } else {
        if (!model.dashboards) {
          model.dashboards = {};
        }
        if (!model.dashboards[d._id]) {
          model.dashboards[d._id] = {};
        }

        model.dashboards[d._id][name] = true;
      }
    });

    this.setState({
      model,
      [e.name]: e.checked
    });
  };

  handleCheck = (e, dashboardId) => {
    const model = this.state.model;

    if (!e.checked) {
      delete model.dashboards[dashboardId][e.name];
    } else {
      if (!model.dashboards) {
        model.dashboards = {};
      }
      if (!model.dashboards[dashboardId]) {
        model.dashboards[dashboardId] = {};
      }

      model.dashboards[dashboardId][e.name] = true;
    }

    this.checkIfAllSelected(model, e.name);
    this.setState({ model });
  };

  isChecked = (dashboardId, name) => {
    const model = this.state.model;
    if (!model.dashboards || !model.dashboards[dashboardId]) {
      return false;
    }
    const dashboard = model.dashboards[dashboardId];
    if (name === 'view') {
      return !!dashboard['view'] || !!dashboard['edit'] || !!dashboard['delete'];
    }

    return !!dashboard[name];
  };

  isDisabled = (dashboardId, name) => {
    const { permissions, dashboards } = this.props;
    if (permissions.manageDashboards || permissions.manageDashboardsViewOnly) {
      return !(name === 'view' || (permissions.manageDashboards));
    } else {
      if (dashboardId) {
        const dashboard = _.find(permissions.dashboards, { dashboardId });
        if (dashboard) {
          return !dashboard[name] || (
            name === 'view' && (
              this.isChecked(dashboardId, 'edit') && this.isDisabled(dashboardId, 'edit') ||
              this.isChecked(dashboardId, 'delete') && this.isDisabled(dashboardId, 'delete')
            ))
        }
      } else {
        return _.some(dashboards, d => {
          const dashboard = _.find(permissions.dashboards, { dashboardId: d._id });
          if (dashboard) {
            return !dashboard[name] || (
              name === 'view' && (
                this.isChecked(d._id, 'edit') && this.isDisabled(d._id, 'edit') ||
                this.isChecked(d._id, 'delete') && this.isDisabled(d._id, 'delete')
              ))
          }
        })
      }
    }
    return true; 
  }

  formatModel = () => {
    const model = { ...this.state.model, users: this.props.users };
    model.dashboards = _(this.state.model.dashboards)
      .mapValues((d, id) => {
        d.dashboardId = id;
        return d;
      })
      .values()
      .value();
    return model;
  };

  hasPermissions = () => {
    return (
      this.state.model.createDashboards ||
      this.state.model.manageBilling ||
      this.state.model.manageUsers ||
      this.state.model.manageDashboards ||
      this.state.model.manageDashboardsViewOnly ||
      _(this.state.model.dashboards)
        .map(d => d.view || d.edit || d.delete)
        .compact()
        .value().length > 0
    );
  };

  handleSendInvitation = () => {
    if (!this.state.model.email) {
      this.props.setError('Email is required');
      return false;
    }
    if (!this.hasPermissions()) {
      this.props.setError("You haven't selected any access rights");
      return false;
    }

    const model = this.formatModel();
    if (model.email) {
      model.email = _(model.email.split(','))
        .map(email => email.trim())
        .filter(email => !!email)
        .value();
    }

    this.props.sendInvitation(model);
    this.onClose();
  };

  handleUpdate = () => {
    if (!this.hasPermissions()) {
      this.props.setError("You haven't selected any access rights");
      return false;
    }
    if (this.props.bulk) {
      this.props.bulkUpdateUsers(this.formatModel());
    } else {
      this.props.updateUser(this.formatModel());
    }

    this.onClose();
  };

  render() {
    const { permissions } = this.props;
    const manageBilling = permissions.manageBilling;
    const manageDashboards = permissions.manageDashboards;
    const manageDashboardsViewOnly = permissions.manageDashboardsViewOnly || permissions.manageDashboards;
    const manageUsers = permissions.manageUsers;
    const createDashboards = permissions.createDashboards;

    var modal = (
      <Modal 
        keyboard={false}
        backdrop='static'
        show={this.state.isOpened}
        onHide={this.onClose}
        className="permissions-modal"
      >
        <Modal.Header>
          <Modal.Title>
            {this.props.bulk
              ? 'Grant bulk permissions'
              : !this.props.model
              ? 'Invite new user'
              : "Edit user's permissions"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="form_content">
          {!this.props.bulk && (
            <Form>
              <Form.Group controlId="email">
                <Form.Label htmlFor="email">
                  Email addresses
                </Form.Label>
                <Form.Control
                  disabled={!!this.props.model}
                  placeholder="Additional email addresses must be separated by a comma"
                  type="textarea"
                  rows="1"
                  name="email"
                  value={this.state.model.email}
                  onChange={e => {
                    e.target.style.overflow = 'hidden';
                    e.target.style.height = 0;
                    e.target.style.height = e.target.scrollHeight + 'px';
                    this.setState({
                      model: {
                        ...this.state.model,
                        email: e.target.value
                      }
                    });
                  }}
                />
              </Form.Group>
            </Form>
          )}

          <div className="box-group general-permissions">
            <label className="form-label">General permissions:</label>
            <div className="flex-group">
              {manageBilling && (
                <Switch
                  id="manageBilling"
                  className="switch_box_right_label"
                  name="manageBilling"
                  label="Manage billing"
                  checked={this.state.model.manageBilling}
                  onChange={this.handleGlobalPermissionsCheck}
                />
              )}
              {manageUsers && (
                <Switch
                  id="manageUsers"
                  className="switch_box_right_label"
                  name="manageUsers"
                  label="Manage users"
                  checked={this.state.model.manageUsers}
                  onChange={this.handleGlobalPermissionsCheck}
                />
              )}

              {(manageDashboards || manageDashboardsViewOnly) && (
                <Switch
                  id="manageDashboards"
                  className="switch_box_right_label"
                  name="manageDashboards"
                  label="Manage all dashboards"
                  checked={this.state.manageDashboards}
                  onChange={this.handleManageDashboardChange}
                />
              )}

              {this.state.manageDashboards && manageDashboardsViewOnly && (
                <RadioButton
                  label="View access only"
                  id="type"
                  name="type"
                  value="viewonly"
                  key="1"
                  checked={this.state.model.manageDashboardsViewOnly}
                  onChange={this.handleRadioBtnChange}
                />
              )}

              {this.state.manageDashboards && manageDashboards && (
                <RadioButton
                  label="Full access"
                  id="type"
                  name="type"
                  value="full"
                  key="2"
                  checked={this.state.model.manageDashboards}
                  onChange={this.handleRadioBtnChange}
                />
              )}
              {createDashboards && (
                  <Switch
                    id="createDashboards"
                    className="switch_box_right_label"
                    name="createDashboards"
                    label="Create dashboards"
                    checked={this.state.model.createDashboards}
                    onChange={this.handleGlobalPermissionsCheck}
                  />
              )}
            </div>
          </div>

          {!this.state.manageDashboards && (
            <div className="box-group">
              <label className="form-label">Dashboard permissions:</label>
              <div className="table-scroll">
                <Table condensed>
                  <thead>
                    <tr>
                      <th>
                        <div className='search-wrap'>
                          <input
                            name="search"
                            placeholder="Search"
                            type="text"
                            id="Search"
                            className="form-control"
                            value={this.state.search}
                            onChange={this.onSearch}
                          />
                        </div>
                      </th>
                      <th>
                        <CheckBox
                          id="viewAll"
                          name="viewAll"
                          label="View"
                          disabled={this.isDisabled(undefined, 'view')}
                          checked={this.state.viewAll}
                          onChange={this.handleAllChecked}
                        />
                      </th>
                      <th>
                        <CheckBox
                          id="editAll"
                          name="editAll"
                          label="Edit"
                          disabled={this.isDisabled(undefined, 'edit')}
                          checked={this.state.editAll}
                          onChange={this.handleAllChecked}
                        />
                      </th>
                      <th>
                        <CheckBox
                          id="deleteAll"
                          name="deleteAll"
                          label="Delete"
                          disabled={this.isDisabled(undefined, 'delete')}
                          checked={this.state.deleteAll}
                          onChange={this.handleAllChecked}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.dashboards.map((d, i) => {
                      return (
                        <tr key={i}>
                          <td>{d.label || d.name}</td>
                          <td>
                            <CheckBox
                              id="view"
                              name="view"
                              label="View"
                              disabled={this.isDisabled(d._id, 'view')}
                              checked={this.isChecked(d._id, 'view')}
                              onChange={e => this.handleCheck(e, d._id)}
                            />
                          </td>
                          <td>
                            <CheckBox
                              id="edit"
                              name="edit"
                              label="Edit"
                              disabled={this.isDisabled(d._id, 'edit')}
                              checked={this.isChecked(d._id, 'edit')}
                              onChange={e => this.handleCheck(e, d._id)}
                            />
                          </td>
                          <td>
                            <CheckBox
                              id="delete"
                              name="delete"
                              label="Delete"
                              disabled={this.isDisabled(d._id, 'delete')}
                              checked={this.isChecked(d._id, 'delete')}
                              onChange={e => this.handleCheck(e, d._id)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                    {!this.state.dashboards.length && (
                      <tr>
                        <td style={{ textAlign: 'center' }} colspan="4">
                          No dashboards found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          
          {!this.props.bulk && !this.props.model ? (
            <Button variant='primary' onClick={this.handleSendInvitation}>
              <img src={mailIcon} alt="" />
              Send invitation
            </Button>
          ) : (
            <Button variant='primary' onClick={this.handleUpdate}>
              <img src={saveIcon} alt="" />
              {this.props.bulk ? 'Bulk Update' : 'Update'}
            </Button>
          )}
          <Button variant='secondary' onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );

    var content;
    if (this.props.children) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          ...this.props,
          onClick: this.onButtonClick
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }

    return content;
  }
}

AddUser.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  model: PropTypes.object
};

AddUser.defaultProps = {
  visible: false
};

const mapDispatchToProps = dispatch => {
  return {
    sendInvitation: model => dispatch(inviteUser(model)),
    updateUser: model => dispatch(updateUser(model)),
    bulkUpdateUsers: model => dispatch(updateUser(model, true)),
    setError: err => dispatch(error(err))
  };
};

const mapStateToProps = state => {
  return {
    dashboards: state.dashboards.list,
    permissions: state.auth.user.permissions,
    manageBilling: !!state.auth.user.permissions && !!state.auth.user.permissions.manageBilling
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
